<style scoped>
</style>
<template>
	<div>
		<Table :columns="columns1" :data="Connectors"></Table>

		<Modal v-model="qrCodeModal" :title="$t('Common.SetQrCode')" width="50%">
			<Form label-position="right" ref="qrCodeForm" :model="qrCodeForm" :label-width="90">
				<Row>
					<Col span="24">
						<FormItem :label="$t('Model.Connector.ConnectorNo')" prop="connectorNo">
							<Input v-model="qrCodeForm.connectorNo" disabled placeholder="">{{ qrCodeForm.connectorNo }}</Input>
						</FormItem>
					</Col>
					<Col span="24">
						<FormItem :label="$t('Model.Connector.QrCode')" prop="remarks">
							<Input v-model="qrCodeForm.qrCode" disabled placeholder="">{{ qrCodeForm.qrCode }}</Input>
						</FormItem>
					</Col>
				</Row>
			</Form>
			<div slot="footer">
				<Button type="default" size="large" @click="qrCodeModal = false">{{ $t('Common.Cancel') }}</Button>
				<Button type="success" size="large" @click="submitQrCode">{{ $t('Common.Confirm') }}</Button>
			</div>
		</Modal>

		<Modal v-model="modalView" :title="modal.Title" width="60%">
			
			<Form label-position="right" v-if="modal.type=='add'||modal.type=='update'" ref="FormItem" :model="FormItem"
				:label-width="90">
				<Row>
					<Col span=8>
					<FormItem :label="this.$t('Model.Connector.PriceId')" prop="Id">
						<Input v-model="FormItem.Id" :placeholder="this.$t('Model.Connector.PriceId')"></Input>
					</FormItem>
					</Col>
					<Col span=8>
					<FormItem :label="this.$t('Model.Connector.PriceName')" prop="Name">
						<Input v-model="FormItem.Name" :placeholder="this.$t('Model.Connector.PriceName')"></Input>
					</FormItem>
					</Col>
					<Col span=8>
					<FormItem :label="this.$t('Model.Connector.EquipmentType')" prop="EquipmentType">
						<Input v-model="FormItem.EquipmentType" :placeholder="this.$t('Model.Connector.EquipmentType')"></Input>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<div v-if="modal.type!='addExcel'" slot="footer">
				<Button v-if="modal.type!='install'" type="warning" size="large" @click="modalCancel">重置</Button>
				<Button type="success" size="large" @click="modalOk">{{ $t('Common.Confirm') }}</Button>
			</div>
		</Modal>
	</div>
</template>
<script>

import webapi from '../../../webapi.js';
	export default {
		props: {
			row: Object
		},
		data() {
			return {
				columns1: [{
						title: this.$t('Model.Connector.ConnectorNo'),
						key: 'ConnectorNo',
					}, 
					{
						title: this.$t('Model.Connector.ConnectorName'),
						key: 'ConnectorName',
					},
					{
						title: this.$t('Model.Connector.ConnectorType'),
						key: 'ConnectorType',
						render: (h, params) => {
							return h('div', this.$options.filters.ConnectorTypeDesc(params.row.ConnectorType))
						}
					},
					{
						title: this.$t('Model.Connector.VoltageLowerLimits')+'(V)',
						key: 'VoltageLowerLimits'
					},
					{
						title: this.$t('Model.Connector.VoltageUpperLimits')+'(V)',
						key: 'VoltageUpperLimits',
					},
					{
						title: this.$t('Model.Connector.Power') +'(KW)',
						key: 'Power',
						// render: (h, params) => {
						// 	return h('div', params.row.StationName)
						// }
					},
					{
						title: this.$t('Model.Connector.Voltage')+'(V)',
						key: 'Voltage',
					},
					{
						title: this.$t('Model.Connector.Current')+'(A)',
						key: 'Current',
					},
					{
						title: this.$t('Model.Connector.BmsPowerType'),
						key: 'BmsPowerType',
						render: (h, params) => {
							return h('div', params.row.BmsPowerTypeDesc)
						}
					},
					{
						title: this.$t('Model.Connector.PriceId'),
						key: 'PriceId',
					}, {
						
						title: this.$t('Model.Connector.EquipmentNo'),
						key: 'EquipmentNo',
					},
					{
						title: this.$t('Model.Connector.QrCode'),
						key: 'QrCode',
					},
					{
						title: this.$t('Model.Connector.Remarks'),
						key: 'Remarks',
					},
							
					{
						title: this.$t('Common.Actions'), 
						key: 'action',
						render: (h, params) => {
							return h('div', [
								h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '8px'
									},
									on: {
										click: () => this.SetQrCode(params.row)
									}
								}, this.$t('Common.SetQrCode')),
		
							]);
						}
					}
				],
				//设备信息中的枪信息列表
				Connectors: this.row.Connectors,
				//价格信息
				FormItem: {},
				//时段价格model
				modal: {
					Title:  this.$t('Model.Connector.EquipmentAdd'),
					type: "add"
				},
				modalView: false,

					// 二维码设置弹窗相关
			    qrCodeModal: false, // 弹窗显示状态
				qrCodeForm: { // 表单数据
					connectorNo: '', // 连接器编号
					qrCode: ''     // 二维码
				}

			}
		},

		methods: {
			show: function(type, ConnectorNo) {
				const _this = this;
				console.log(ConnectorNo)
				for (let i = 0; i < _this.row.Connectors.length; i++) {
					if (ConnectorNo == _this.row.Connectors[i].ConnectorNo) {
						_this.FormItem = _this.row.Connectors[i].PriceInfo
					}
				}
				_this.modalView = true
			},
			modalCancel: function(actionType) {
				this.modalView = false
			},
			modalOk: function(actionType) {
				this.modalView = false
			},

			SetQrCode(row) {
				
				console.log('SetQrCode：', row);
				const baseUrl = window.location.origin;
				const qrCodeUrl = `${baseUrl}/qr?connectorNo=${row.ConnectorNo}`;
				// 初始化表单数据
				this.qrCodeForm = {
					connectorNo: row.ConnectorNo,
					qrCode: qrCodeUrl
				};
				// 打开弹窗
				this.qrCodeModal = true;
				
			},

			submitQrCode() {
				const _this = this;
				var param = {
					ConnectorNo: this.qrCodeForm.connectorNo,
					QrCode: this.qrCodeForm.qrCode 
				};
				

				this.$axios.post(webapi.base_api_url + '/Archives/SetQrCode', param)
					.then(res => {
						console.log(res);
						console.log("Code="+res.data.Code);
						if (res.data.Code == 0) {
							_this.$Message.success(
								_this.$t('Common.SetQrCode') + _this.$t('Common.Success')
							);
							_this.qrCodeModal = false;
						} else {
							_this.$Message.error(_this.$t('Common.SetQrCode')+"," +_this.$t('Common.Failed')+","+_this.$t('Common.CheckDeviceStatus'));
						}
					})
					.catch(error => {
						console.error('Request fail ', error);
						_this.$Message.error(_this.$t('Common.SetQrCode')+"," +_this.$t('Common.Failed')+","+_this.$t('Common.CheckDeviceStatus'));
					});
			},


		}
	};
</script>
